import { useEffect, useState } from 'react';
import {
  incrementEngagement,
  isSubmitted,
  isSnoozed,
  ENGAGEMENT_THRESHOLD,
} from '@/components/feedback/feedbackStorage';

/**
 * Decides whether the proactive feedback modal is eligible to appear.
 *
 * Bumps a per-session engagement counter once on mount (AppLayout stays mounted
 * across in-app navigation, so this runs once per app load). The modal becomes
 * eligible after the user has come back a few times, hasn't already submitted
 * feedback, and isn't currently snoozed.
 *
 * Returns only eligibility — the host component owns timing (e.g. delay, route
 * gating) and snoozing on dismiss.
 */
export function useFeedbackPrompt(): boolean {
  const [eligible, setEligible] = useState(false);

  useEffect(() => {
    const count = incrementEngagement();
    if (count >= ENGAGEMENT_THRESHOLD && !isSubmitted() && !isSnoozed()) {
      setEligible(true);
    }
  }, []);

  return eligible;
}
